import React, { createContext, useContext, useEffect, useState } from 'react';
import { getCurrentSupervisor, primeCsrf, supervisorLogin, supervisorLogout } from '../api/auth';

const SupervisorAuthContext = createContext(null);

export const SupervisorAuthProvider = ({ children }) => {
  const [supervisor, setSupervisor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await primeCsrf();
        const current = await getCurrentSupervisor();
        if (!cancelled) setSupervisor(current);
      } catch (err) {
        // Pas de session superviseur active — reste sur l'ecran de login.
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const login = async (username, password) => {
    const loggedInSupervisor = await supervisorLogin(username, password);
    setSupervisor(loggedInSupervisor);
    return loggedInSupervisor;
  };

  const logout = async () => {
    // Best-effort : si la session etait deja expiree/invalide cote serveur (ex.
    // double-clic sur "Deconnexion"), l'etat vise ("plus authentifie") est de
    // toute facon deja atteint — on ne bloque jamais la navigation pour ca.
    try {
      await supervisorLogout();
    } catch (err) {
      // ignore
    }
    setSupervisor(null);
  };

  return (
    <SupervisorAuthContext.Provider value={{ supervisor, loading, login, logout }}>
      {children}
    </SupervisorAuthContext.Provider>
  );
};

export const useSupervisorAuth = () => {
  const ctx = useContext(SupervisorAuthContext);
  if (!ctx) throw new Error('useSupervisorAuth must be used within a SupervisorAuthProvider');
  return ctx;
};
